import {
  Component,
  input,
  InputSignal,
  ViewEncapsulation
} from '@angular/core';

@Component({
  selector: 'td-wb-card-content',
  template: '<ng-content />',
  styleUrls: ['card-content.component.scss'],
  encapsulation: ViewEncapsulation.None,
  host: {
    'class': 'td-wb-card-content',
    '[class.td-wb-card-content--center]': 'align() === "center"',
    '[class.td-wb-card-content--end]': 'align() === "end"'
  }
})
export class CardContentComponent {
  align: InputSignal<'start' | 'center' | 'end'> = input<'start' | 'center' | 'end'>('start');
}
